import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { UserActivityProvider } from "../contexts/UserActivityContext";
import { DialogProvider } from "../contexts/DialogContext";

export const UserActivityComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[<UserActivityProvider key={0} />, <DialogProvider key={1} />]}
    >
      {children}
    </ContextProviderComposer>
  );
};

export default UserActivityComposer;
